import useSWR from 'swr';
import { ORDERBOOK } from '../../constants/APIKEYS';

let swrData: any = { data: { long: [], short: [], ep_id: 0 } };

export function useOrderBook(ep_id: string | number) {
  const KEY = `${ORDERBOOK}/${ep_id}`;
  const { data, mutate } = useSWR<any>(
    KEY,
    async () => {
      if (!swrData || !swrData.data) {
        swrData = { data: { long: [], short: [], ep_id: 0 } };
      }
      return swrData.data;
    },
    {
      revalidateIfStale: false,
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
    }
  );

  return {
    data: data || { long: [], short: [], ep_id: 0 },
    mutate: async (value?: any) => {
      try {
        if (value !== undefined) {
          swrData = { data: value };
        }
        if (value === null) {
          swrData = { data: { long: [], short: [], ep_id: 0 } };
        }
        return mutate ? mutate(swrData?.data) : swrData?.data;
      } catch (error) {
        console.error('Mutate error:', error);
        return swrData?.data || { long: [], short: [], ep_id: 0 };
      }
    },
  };
}
